import React from "react";
import "./Home.scss";
import TopicBlock from "../../components/topic-block/TopicBlock";
// import Carousel from 'react-bootstrap/Carousel';
import { Icon, Button, Input } from "../../components/ui/index";
// @ts-ignore
import Carousel from "react-grid-carousel";

const Home = () => {
  return (
    <div>
      <Banner />
      <div className="home">
        <div className="wrapper">
          <TopicBlock />
        </div>
        <NewsLetter />
      </div>
    </div>
  );
};

const MyDot = ({ isActive }: { isActive: Boolean }) => (
  <span
    style={{
      borderRadius: "50%",
      display: "inline-block",
      height: "10px",
      width: "10px",
      background: isActive ? "#fff" : "#000",
      margin: "0 4px",
    }}
  ></span>
);

const Banner = () => {
  return (
    <Carousel
      dot={MyDot}
      gap={0}
      hideArrow={true}
      loop
      showDots={true}
      autoplay={4000}
      containerClassName="carousel-banner"
    >
      <Carousel.Item>
        <Icon className="d-block w-100" imgPath="/images/banner/0000207.png" />
      </Carousel.Item>
      <Carousel.Item>
        <Icon className="d-block w-100" imgPath="/images/banner/0000208.jpeg" />
      </Carousel.Item>
    </Carousel>
  );
};

const NewsLetter = () => {
  return (
    <div className="newsletter">
      <div className="container">
        <div className="newsletter-subscribe" id="newsletter-subscribe-block">
          <h2 className="text heading medium uppercase white">
            Subscribe to our newsletter
          </h2>
          <p>
            Sign up to our e-mail newsletter to be the first to hear about great
            offers &amp; more
          </p>
          <div className="newsletter-email">
            <div className="form">
              <input
                id="newsletter-email-blank"
                name="newsletter-email-blank"
                type="hidden"
                value="Please enter your email address"
              />
              <div className="newsletter-input">
                <Input
                  className="input form-text newsletter-subscribe-text"
                  id="newsletter-email"
                  name="NewsletterEmail"
                  placeholder="Your e-mail address"
                  type="text"
                />
                <span className="newsletter-email-validation"></span>
              </div>
              <Button className="button secondary-button">Subscribe</Button>
            </div>
          </div>
        </div>
        <div
          className="newsletter-result text heading medium white"
          id="newsletter-result-block"
        >
          <h2></h2>
          <div className="input-container">
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
